import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  getIn,
} from 'formik';
import PropTypes from 'prop-types';
import { Inputs } from '@bagonboard/ui-kit';
import { SERVICE_TYPES } from '@bagonboard/wiseman';

import * as actions from '../../../../../../reducers/Area/actions';
import * as poiActions from '../../../../../../reducers/Poi/actions';

const { Address } = Inputs;
const {
  TRANSFER, CHECKIN,
} = SERVICE_TYPES;

const getFormError = (form, prop) => getIn(form.touched, prop) && getIn(form.errors, prop);

const getAddressError = (form, prop, postalCodes, postalCode) => {
  const address = getIn(form, 'values.service.address');
  const hasNumber = address && postalCode && address.street && !address.street.includes('undefined');
  const outOfCoverage = !postalCodes.includes(postalCode);
  if (postalCode && outOfCoverage) return 'Address out of coverage';
  if (!hasNumber) return 'Please, add a number';
  const srcError = getFormError(form, prop);
  if (!srcError) {
    return srcError;
  }
  return Object.values(srcError)[0];
};
const updateAddress = (field, form, poiId, area) => (address) => {
  const parsedValue = address || {};
  form.setFieldTouched(field.name, true);
  form.setFieldValue(field.name, { ...parsedValue, poi: poiId, cityCode: area });
};

const getLabelText = serviceType => (
  [CHECKIN, TRANSFER].includes(serviceType) ? 'Pickup Address' : 'Delivery Address'
);

const getAreaFromFlight = (flightSelected, serviceType, flightProductsData) => {
  const {
    flight:
    {
      flightData: {
        origin: { airportCode: originAirportCode },
        destination: { airportCode: destinationAirportCode },
      },
    },
  } = flightProductsData[flightSelected];
  return [CHECKIN, TRANSFER].includes(serviceType)
    ? originAirportCode
    : destinationAirportCode;
};

const AddressForm = ({
  areaFetch, poiFetch, field, form, areaData, flighProductsData, poiId,
}) => {
  const addressTouched = getIn(form.touched, field.name);
  const serviceType = getIn(form, 'values.service.type');
  const postalCode = getIn(form, 'values.service.address.postalCode');
  const { center, postalCodes } = areaData;
  const flightSelected = getIn(form, 'values.flightSelected');
  const area = getAreaFromFlight(flightSelected, serviceType, flighProductsData);
  useEffect(() => {
    async function fetchAreaData() {
      await Promise.all([areaFetch({ area }), poiFetch({ area })]);
    }
    fetchAreaData();
  }, [area, areaFetch, poiFetch]);
  if (!serviceType || !center || !postalCodes || !flighProductsData) {
    return null;
  }
  const error = addressTouched && getAddressError(form, field.name, postalCodes, postalCode);
  return (
    <Address
      location={center}
      coverage={postalCodes}
      id="address"
      label={getLabelText(serviceType)}
      handleBlur={updateAddress(field, form, poiId, area)}
      handleChange={updateAddress(field, form, poiId, area)}
      width="100%"
      error={error}
    />
  );
};

AddressForm.defaultProps = {
  poiId: undefined,
};

AddressForm.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.object.isRequired,
    values : PropTypes.shape({
      service: PropTypes.shape({
        address: PropTypes.object,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  areaFetch: PropTypes.func.isRequired,
  poiFetch : PropTypes.func.isRequired,
  poiId    : PropTypes.string,
  areaData : PropTypes.shape({
    center: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }),
    postalCodes: PropTypes.array,
  }).isRequired,
  flighProductsData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({
  area: { data: areaData },
  poi : { data: poiId },
  flightProducts: { data: flighProductsData },
}) => ({
  areaData,
  flighProductsData,
  poiId,
});

const mapDispatchToProps = dispatch => ({
  areaFetch: data => dispatch(actions.areaFetch(data)),
  poiFetch : data => dispatch(poiActions.poiFetch(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddressForm);
